import { Box, Text } from '@chatsdet/ui';
type PayloadEditorProps = {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
};

export function PayloadEditor({ value, onChange, disabled }: PayloadEditorProps) {
  return (
    <Box>
      <Text size="xs" className="text-muted-foreground mb-1 block">
        Payload (JSON)
      </Text>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-border rounded-md px-3 py-2 text-sm font-mono min-h-[120px] bg-background"
        spellCheck={false}
        disabled={disabled}
      />
    </Box>
  );
}
